import config from '@config'
import usePageMetadata from './usePageMetadata'
import useUTMQueryParams from './useUTMQueryParams'

const {
  auth: { ssoSourceSuffix },
} = config

export type UseSSOTrackingSource = (options: {
  prefix: string
  omitPublication?: boolean
}) => string

const useSSOTrackingSource: UseSSOTrackingSource = ({
  prefix,
  omitPublication,
}) => {
  const {
    title: sectionSSO,
    id: articleIdSSO,
    ressort: articleSectionSSO,
  } = usePageMetadata()

  const utmQueryParams = useUTMQueryParams()

  const pageSuffix = articleIdSSO
    ? `${articleSectionSSO}_ARTICLE_${articleIdSSO}`
    : `${sectionSSO}`

  const utmSuffix = (
    Object.keys(utmQueryParams) as (keyof typeof utmQueryParams)[]
  ).reduce((acc, urlParamKey) => {
    const utmQueryParamValue = utmQueryParams[urlParamKey]
    return utmQueryParamValue
      ? `${acc}_${urlParamKey}_${utmQueryParamValue}`
      : acc
  }, '')

  const publicationSuffix = omitPublication ? '' : `_${ssoSourceSuffix}`

  const trackingSource = `${prefix}_${pageSuffix}${utmSuffix}${publicationSuffix}`

  return trackingSource
}

export default useSSOTrackingSource
